import { css } from '@emotion/react';
import type { ColorResult } from '~/_shared/components/colorPicker/colorPicker.types';
import type { Theme } from '~/_shared/themes/theme.model';

const UNIT_INPUT_WIDTH = 104;

export const formStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  padding: 16,
});

export const distanceStyle = css({
  alignItems: 'flex-end',
  display: 'flex',
  gap: 12,
});

export const sliderStyle = css({
  paddingBottom: 16,
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: '0%',
});

export const unitStyle = css({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: UNIT_INPUT_WIDTH,
});

export const settingStyle = css({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 14,
  gap: 4,
});

export const labelStyle = css({
  fontSize: 14,
  textTransform: 'uppercase',
});

export const exampleStyle = css({
  fontSize: 12,
  textTransform: 'none',
});

export const hideStyle = css({
  visibility: 'hidden',
});

export const buttonStyle = css({
  height: 48,
  marginTop: 8,
  width: '100%',
});

export const loaderContainerStyle = (theme: Theme) => css({
  backgroundColor: theme.backgroundColors.primary,
  color: theme.textColors.primary,
  fontSize: 20,
  height: '100%',
  position: 'relative',
  width: 30,
});

export const inputSuffixButtonStyle = (theme: Theme) => css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  background: 'none',
  border: 'none',
  color: 'inherit',
  transition: 'color .15s',
  '&:hover': {
    color: theme.textColors.link,
  },
});

export const placesSearchItemPanelStyle = css({
  padding: 0,
});

export const placesToolAlertStyle = css({
  marginTop: 8,
});

export const placeCircleStyle = ({
  backgroundColor,
  color,
}: {
  backgroundColor: ColorResult;
  color: ColorResult;
}) => css({
  width: 20,
  height: 20,
  borderRadius: '50%',
  backgroundColor: backgroundColor.hex,
  color: color.hex,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 14,
});
